import React from "react";

const FacilityProfileChartPlaceholder = () => {
    return (
        <div className="results-map-placeholder">
            <div
                className="animated-background"
                style={{ height: "1000x", width: "100%" }}
            />
        </div>
    );
};

export default FacilityProfileChartPlaceholder;
